import { render, staticRenderFns } from "./DetailedResultsView.vue?vue&type=template&id=644da7bd&"
import script from "./DetailedResultsView.vue?vue&type=script&lang=ts&"
export * from "./DetailedResultsView.vue?vue&type=script&lang=ts&"
import style0 from "./DetailedResultsView.vue?vue&type=style&index=0&id=644da7bd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports